module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"appliedDiscounts":"Applied discounts"},"de":{"appliedDiscounts":"Angewandte Rabatte"}}')
  delete Component.options._Ctor
}
